const lookupRiverIceType = int => {
  switch (int) {
    case 1:
      return 'Open water'
    case 2:
      return 'Smooth ice'
    case 3:
      return 'Consolidated ice'
    default:
      return null
  }
}

export default lookupRiverIceType



// WEBPACK FOOTER //
// ./src/utility/lookupRiverIceType.js